import { JsonSchemaValidator } from "@common/json-schema-validator";
import {
  LicenseExpireAtMs,
  LicenseIsDefault,
  LicenseIssuedAtMs,
  LicenseMaxLiveDurationMs,
  LicenseNextLiveDelayMs
} from "../interface";
import {
  licenseExpireAtMs,
  licenseIsDefault,
  licenseIssuedAtMs,
  licenseMaxDurationMs,
  licenseNextLiveDelayMs
} from "../schema";

export class LicenseEntity {
  private static configValidation = JsonSchemaValidator.compile(
    LicenseEntity.configValidationSchema()
  );

  constructor(readonly entity: License) {
    JsonSchemaValidator.assert(LicenseEntity.configValidation, entity);
  }

  toJSON() {
    return this.entity;
  }

  private static configValidationSchema() {
    return {
      type: "object",
      required: ["default", "issuedAtMs"],
      properties: {
        default: licenseIsDefault,
        maxLiveDurationMs: licenseMaxDurationMs,
        nextLiveDelayMs: licenseNextLiveDelayMs,
        expireAtMs: licenseExpireAtMs,
        issuedAtMs: licenseIssuedAtMs
      },
      additionalProperties: false
    };
  }
}

export interface LicenseEntityJson {
  default: LicenseIsDefault;
  maxLiveDurationMs?: LicenseMaxLiveDurationMs;
  nextLiveDelayMs?: LicenseNextLiveDelayMs;
  expireAtMs?: LicenseExpireAtMs;
  issuedAtMs: LicenseIssuedAtMs;
}

interface License {
  default: LicenseIsDefault;
  maxLiveDurationMs?: LicenseMaxLiveDurationMs;
  nextLiveDelayMs?: LicenseNextLiveDelayMs;
  expireAtMs?: LicenseExpireAtMs;
  issuedAtMs: LicenseIssuedAtMs;
}
